module.exports = "static/assets/306ffbcffad0d931fb1d158dd812f3fe.svg";